export default __webpack_public_path__ + "static/media/ios-guild-background.c5cde123.png";